type SpinnerProps = {
  size?: "sm" | "md" | "lg";
  className?: string;
  label?: string;
};

const sizeClass = {
  sm: "spinner-sm",
  md: "spinner",
  lg: "h-12 w-12 border-[3px]",
};

export default function Spinner({ size = "md", className = "", label }: SpinnerProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 ${className}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className={sizeClass[size]} aria-hidden="true" />
      {label ? <p className="text-sm text-ink-muted">{label}</p> : null}
      {!label ? <span className="sr-only">Loading</span> : null}
    </div>
  );
}
